export const SSE_EVENTS = {
  APPROVED: 'approved',
  CANDIDATES_MATCHED: 'candidates_matched',
  JOB_ASSIGNED: 'job_assigned',
  JOB_CLOSED: 'job_closed',
  JOB_CREATED: 'job_created',
  JOB_PUBLISHED: 'job_published',
  JOB_SCORED: 'job_scored',
  JOB_STATUS_CHANGED: 'job_status_changed',
  JOB_UPDATED: 'job_updated',
  SHORTLISTED: 'shortlisted',
  SUBMITTED: 'submitted',
  SUBMITTED_FOR_REVIEW: 'submitted_for_review',
} as const;

export type SSEEventType = (typeof SSE_EVENTS)[keyof typeof SSE_EVENTS];

export interface SSEEvent<T = any> {
  type: SSEEventType;
  data: T;
  timestamp: number;
}
